import type { RecordBatchMetaResponse } from "@/lib/types";
import type { RecordsGatewayPort } from "@/application/records/ports/RecordsGatewayPort";
import type { RecordsMetaBatchRequestOptions } from "@/lib/records-meta-batch";

export interface FetchRecordsMetaBatchInputDto {
  recordIds: string[];
  options?: RecordsMetaBatchRequestOptions;
}

/**
 * Use case: пакетная загрузка метаданных записей.
 */
export class FetchRecordsMetaBatchUseCase {
  constructor(private readonly gateway: RecordsGatewayPort) {}

  async execute(
    input: FetchRecordsMetaBatchInputDto
  ): Promise<Record<string, RecordBatchMetaResponse>> {
    const { recordIds, options } = input;
    return this.gateway.getRecordsMetaBatch(recordIds, options);
  }
}
